import { render } from "./CheckboxGroup.vue?vue&type=template&id=26ae2e3a&ts=true"
import script from "./CheckboxGroup.vue?vue&type=script&lang=ts"
export * from "./CheckboxGroup.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__